











































































import { ChoiceOption, ChoiceOptionList } from '@/interfaces';
import { api } from '@/api';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
// import { Getter } from 'vuex-class';

@Component({
  components: {}
})
export default class AddressField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: String, default: '3' }) public readonly labelCols!: string;
  @Prop({ type: String, default: '9' }) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: true }) public readonly clearable!: boolean;
  @Prop({ type: String, default: 'Postcode' })
  public readonly labelPostalcode!: string;
  @Prop({ type: String, default: 'postal_code' })
  public readonly fieldPostalcode!: string;
  @Prop({ type: String, default: 'Plaats' }) public readonly labelCity!: string;
  @Prop({ type: String, default: 'city' }) public readonly fieldCity!: string;

  public validateErrorsPostalCode: string[] = [];
  public validateErrorsCity: string[] = [];
  public dialog = false;
  public loading = false;
  public items: ChoiceOption[] = [];
  public searchResult: object = {};

  public myrules = {
    required: (v) => {
      return !!v || 'Dit veld is verplicht.';
    }
  };

  public get allRules() {
    const rules = [] as any;
    if (this.required) {
      rules.push(this.myrules.required);
    }
    return rules;
  }

  public async doSearch(theSearchString, params) {
    this.loading = true;
    const data = await api.getChoices(this.$store, '/cities/choice/', params);
    if (data) {
      this.items = data.records;
      if (this.items.length === 1) {
        this.setCity(this.items[0]);
      } else if (this.items.length > 1) {
        this.searchResult = this.items[0];
        this.dialog = true;
      }
    }
    this.loading = false;
  }
  public setCity(item) {
    this.rec[this.fieldPostalcode] = item.postal_code;
    this.rec[this.fieldCity] = item.city;
  }
  public async inputPostalCode(v) {
    if (v && v.length > 3) {
      this.doSearch(v, { postal_code: v });
    }
  }

  public async inputCity(v) {
    if (v && v.length >= 3) {
      this.doSearch(v, { city: v });
    }
  }
}
